require('./').install();